interface JdLogoProps {
  readonly className: string;
}

export function JdLogo({ className }: JdLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 135.5 135.5"
      class={className}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="jd-logo-a" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="21.35%" stop-color="#734527" />
          <stop offset="49.99%" stop-color="#673d23" />
          <stop offset="72.81%" stop-color="#724323" />
        </linearGradient>
        <linearGradient id="jd-logo-b" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="4.16%" stop-color="#d57d00" />
          <stop offset="36.63%" stop-color="#e5aa0a" />
          <stop offset="58.29%" stop-color="#e8b633" />
        </linearGradient>
        <linearGradient id="jd-logo-c" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stop-color="#f1a906" />
          <stop offset="31.46%" stop-color="#deac2e" />
          <stop offset="79.88%" stop-color="#da9e29" />
        </linearGradient>
        <linearGradient id="jd-logo-d" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="10.14%" stop-color="#fffbf4" />
          <stop offset="84.26%" stop-color="#dfa144" />
          <stop offset="100%" stop-color="#ddae50" />
        </linearGradient>
        <linearGradient id="jd-logo-e" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="0%" stop-color="#e7be61" />
          <stop offset="23.55%" stop-color="#deaa39" />
          <stop offset="100%" stop-color="#d9ac47" />
        </linearGradient>
        <linearGradient id="jd-logo-f" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="0.09%" stop-color="#ffffe2" />
          <stop offset="87.79%" stop-color="#ffffef" />
          <stop offset="100%" stop-color="#e0d1a9" />
        </linearGradient>
        <linearGradient id="jd-logo-g" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="5.01%" stop-color="#dd9a34" />
          <stop offset="64.77%" stop-color="#f6d07f" />
          <stop offset="95.97%" stop-color="#ffe396" />
        </linearGradient>
        <radialGradient id="jd-logo-h" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="1" fx="0" fy="0" gradientTransform="matrix(26.87016862 0 0 21.30396051 47.63671875 54.25292969)">
          <stop offset="9.6873%" stop-color="#fcc509" />
          <stop offset="45.8959%" stop-color="#e97a01" />
          <stop offset="89.8223%" stop-color="#d20102" />
        </radialGradient>
        <linearGradient id="jd-logo-i" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="28.57%" stop-color="#fffefa" />
          <stop offset="68.2%" stop-color="#f4e6c9" />
          <stop offset="98.51%" stop-color="#efd18e" />
        </linearGradient>
        <linearGradient id="jd-logo-j" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="12.54%" stop-color="#f69c51" />
          <stop offset="42.09%" stop-color="#ffd585" />
          <stop offset="85.44%" stop-color="#f5a58b" />
        </linearGradient>
        <linearGradient id="jd-logo-k" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="0.01%" stop-color="#76502b" />
          <stop offset="15.08%" stop-color="#684126" />
          <stop offset="34.1%" stop-color="#704327" />
        </linearGradient>
        <linearGradient id="jd-logo-l" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="52.95%" stop-color="#fffdf7" />
          <stop offset="79.96%" stop-color="#fff8e9" />
          <stop offset="100%" stop-color="#f3d7ad" />
        </linearGradient>
        <linearGradient id="jd-logo-m" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="0.01%" stop-color="#fbeac8" />
          <stop offset="19.16%" stop-color="#fef4d8" />
          <stop offset="100%" stop-color="#fcf8df" />
        </linearGradient>
        <linearGradient id="jd-logo-n" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stop-color="#abaaa9" />
          <stop offset="70.24%" stop-color="#616161" />
          <stop offset="91.01%" stop-color="#938c7e" />
        </linearGradient>
      </defs>
      <path fill="url(#jd-logo-a)" d="M11 55.7c1.9-11 31.4-14 45.1-14s47 2.5 47.2 13.6l.3 8s14.6-.2 15.7 1.4 6.2 7.7 5.5 14.5c-.8 6.9-2.7 13.3-21.2 24.1l-.2 10s-1.2 3.3-2.7 4.4 C100.7 122.7 96.7457 124.83 88.1673 127.3165 C79.5889 129.8029 68.3545 131.1 57 131.1 C45.6455 131.1 34.4111 129.8029 25.8327 127.3165 C17.2543 124.83 13.1 122.45 13.1 117.7 C13.1 117.7 10.6 115.6 10.8 111.4" />
      <path fill="url(#jd-logo-b)" d="M97.7 109.3s.7 7.5.2 10 C97.65 120.6 95.5897 122.2498 87.3878 124.6271 C79.186 127.0045 68.142 128.3 57 128.3 C45.858 128.3 34.814 127.0045 26.6122 124.6271 C18.4103 122.2498 16.2 119.65 16.2 118 L17.2 110.1" />
      <path fill="url(#jd-logo-c)" d="M13.2 55.5c9.9-17.3 87.2-14 87.2 1.4v9.6s15.1-1 16.7.4 4.5 7.4 4.5 11 0 13.5-21 23.8l-.2 11.6 C100.5 116.5 94.8052 120.499 86.8589 122.8023 C78.9125 125.1056 67.9979 126.4 57 126.4 C46.0021 126.4 35.0875 125.1056 27.1411 122.8023 C19.1948 120.499 13.3 115.75 13.4 112.8" />
      <path fill="url(#jd-logo-d)" d="M97 68.8s17.8-2.2 19.6-.2c1.7 1.9 4.3 8.4 3.5 12-.8 3.4-2.2 11.3-23.3 21.2" />
      <path fill="url(#jd-logo-e)" d="M94.7 81.4s15-3.4 16-2.5c1.1.8 2.7 2.8-.4 6C107 88.3 95 96 95 96z" />
      <path fill="url(#jd-logo-f)" d="M98.4 112.3 C98.4 115.6 93.9382 118.5638 86.2742 120.7853 C78.6102 123.0067 67.8385 124.3 57 124.3 C46.1615 124.3 35.3898 123.0067 27.7258 120.7853 C20.0618 118.5638 15.6 115.45 15.6 112.3 V56.6h82.7z" />
      <path fill="url(#jd-logo-g)" d="M91.5 59.4c-34.4 16.2-69.6-.2-69.6-.2s-8.7-11.4 33.6-12.5c40.6-1 40.7 13 36 12.7" />
      <path fill="url(#jd-logo-h)" d="M22.7 60.2c13.9-9.8 59.9-8.6 68.3.2-12.9 7.9-56.2 8.9-68.3-.2" />
      <path fill="url(#jd-logo-i)" d="M57 46a41.4 10.9 0 0 0-41.5 11A41.4 10.9 0 0 0 57 67.7a41.4 10.9 0 0 0 41.4-10.9A41.4 10.9 0 0 0 57 46m0 2.1A34.4 8.7 0 0 1 91.5 57 34.4 8.7 0 0 1 57 65.6 34.4 8.7 0 0 1 22.6 57 34.4 8.7 0 0 1 57 48" />
      <path fill="url(#jd-logo-j)" d="M75.5 56.3c-33.8-4.4-47.5 3-47.5 3s6.8 4.3 11.4 2.6c4.5-1.6 7.5-3 17.2-2.7 17.8.6 19-2.9 19-2.9" opacity=".8" />
      <path fill="url(#jd-logo-k)" d="M100.6 89.7V82s9.6-2.3 9.6-1.4c0 1 .6 2.4-9.6 9" />
      <path fill="url(#jd-logo-l)" fill-opacity=".9" d="M100.5 76s13-1 14 1.1c.9 1.8-.2 4.3-.7 6.5 0 0 5.4-7.4 2-11-3-3.1-12.8.7-15.3 3.4" />
      <path fill="url(#jd-logo-m)" d="M100.2 98.2s14.3-6.3 15.2-12.8c0 0-3 4.7-15.2 12.8" />
      <path fill="url(#jd-logo-n)" d="M62.8 4.3c11.2 8.1 7.9 12.7-5 18.5-7 3-14.7 3.6-15.1 10.8.2 6 4.6 9.4 8.9 13.5 4.2 4 4.9 6.2 4.9 6.2s16.7-2.4 11.3-6.8S58.2 37 62.1 35c4-2 17.8-6 18-12 0-5.9-10.3-15.8-17.3-18.7" opacity=".8" />
    </svg>
  );
}
